import { useQuery } from '@tanstack/react-query';

import { fetchTenantConfig } from 'common/api/tenantConfig';

export const useTenantConfigQuery = (countryCode?: string) => {
  return useQuery({
    queryKey: ['tenantConfig', countryCode],
    queryFn: () => fetchTenantConfig(countryCode),
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    retry: 1,
  });
};
